import React from 'react';

// Terms & Privacy for the public lead forms. Hosted on the same server that
// stores the leads (mycard.tecgs.com), linked from the consent checkbox on the
// card and microsite. Plain, editable, no external dependency.
export default function Terms() {
  const updated = 'July 2026';
  return (
    <div style={{ minHeight: '100vh', background: '#f4f7f5', padding: '32px 18px 72px', fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,Arial,sans-serif", color: '#1d2a23' }}>
      <div style={{ maxWidth: 720, margin: '0 auto', background: '#fff', borderRadius: 14, boxShadow: '0 2px 12px rgba(0,0,0,.06)', overflow: 'hidden' }}>
        <div style={{ background: 'linear-gradient(135deg,#0e3b2a,#0b6e3e)', padding: '22px 26px', display: 'flex', alignItems: 'center', gap: 14 }}>
          <img src="/dfci-logo.png" alt="Diabetik Foot Care India" style={{ height: 44, width: 44, background: '#fff', borderRadius: 10, padding: 4 }} />
          <div>
            <div style={{ color: '#fff', fontSize: 18, fontWeight: 700 }}>Diabetik Foot Care India</div>
            <div style={{ color: '#bfe6cf', fontSize: 12.5 }}>Terms &amp; Privacy</div>
          </div>
        </div>

        <div style={{ padding: '26px 28px', fontSize: 15, lineHeight: 1.7 }}>
          <p style={{ color: '#5b6b61', fontSize: 13, marginTop: 0 }}>Last updated: {updated}</p>

          <p>
            When you share your details through a Diabetik Foot Care India digital visiting card or
            microsite, you are asking a member of our team to get in touch with you. This page
            explains what we collect and how we use it.
          </p>

          <h2 style={h2}>What we collect</h2>
          <p>Only what you type into the contact form — your name, your business or clinic, and,
             if you choose to give it, your email. If you continue on WhatsApp, we also see the
             mobile number WhatsApp shows us.</p>

          <h2 style={h2}>Why we collect it</h2>
          <p>To respond to your enquiry and to let the relevant Diabetik Foot Care India
             representative contact you about our diabetic foot-care products and services. We do
             not sell your details to anyone.</p>

          <h2 style={h2}>Your consent</h2>
          <p>We record your details only after you tick the consent box on the form. That tick,
             and the time you made it, are stored with your enquiry as a record that you agreed to
             be contacted.</p>

          <h2 style={h2}>How long we keep it</h2>
          <p>We keep your enquiry for as long as needed to follow up and maintain our business
             relationship. You can ask us to stop contacting you or to delete your details at any
             time using the contact below.</p>

          <h2 style={h2}>Contact us</h2>
          <p>
            Diabetik Foot Care India Pvt Ltd<br />
            18/1, Kannappanagar 3rd Main Road, Thiruvanmiyur, Chennai 600 041, India<br />
            Email: <a href="mailto:mesmedi@gmail.com" style={a}>mesmedi@gmail.com</a><br />
            Web: <a href="https://www.diabetikfootcareindia.com" style={a} target="_blank" rel="noreferrer">www.diabetikfootcareindia.com</a>
          </p>

          <p style={{ color: '#7b8a80', fontSize: 12.5, marginTop: 26, borderTop: '1px solid #e6ece8', paddingTop: 16 }}>
            Platform powered by TECGSOFT. Enquiry records are stored securely on the TECGSOFT server.
          </p>
        </div>
      </div>
    </div>
  );
}

const h2 = { fontSize: 15.5, fontWeight: 700, color: '#0b6e3e', margin: '22px 0 4px' };
const a = { color: '#0b6e3e', fontWeight: 600 };
